import { RootState } from 'editor/src/store/index';

const isPersonalizationLockIgnored = (state: RootState) => state.hostSettings.ignorePersonalizationLock;

export default isPersonalizationLockIgnored;
